.feedback {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-4);
  margin-top: var(--tuna-spacing-3);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
}

.header {
  margin: 0;
  font-weight: 700;
  font-size: var(--tuna-typography-body1-fontSize);
}

.correct {
  color: var(--tuna-feedback-success);
}

.incorrect {
  color: var(--tuna-feedback-error);
}

.body {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  line-height: 1.5;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: var(--tuna-spacing-2);
}
